<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    ref="frame"
    class="popup-wrapper">
    <div class="flex flex-col popup-background" tabindex="1">
      <div class="w-full flex-grow-1 flex popup-row" v-for="service in services" :key="service._id">
        <input type="checkbox" :checked="local_selected_services.includes(service._id)"
               @change="service_selected($event, service)" />
        <span>{{service.name}}</span>
      </div>

      <div class="w-full mt-4">
        <div class="popup-button" @click="confirm">Confirm</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    services: {
      type: Array
    },
    updated: {
      type: Function
    }
  },
  name: 'SelectServicePopup',
  mounted () {
    this.local_selected_services = JSON.parse(JSON.stringify(this.selected_services))
    console.log('loc select servi', this.local_selected_services, this.services)
  },
  data () {
    return {
      local_selected_services: []
    }
  },
  computed: {
    selected_services () {
      return this.$store.state.selected_services
    }
  },
  methods: {

    handleFocus () {
      // do something here
      console.log('in')
      this.confirm()
    },
    handleFocusOut () {
      // do something here
      console.log('out')
    },
    confirm () {
      this.updated(this.local_selected_services)
      this.local_selected_services = []
    },
    service_selected (e, service) {
      console.log(e.target.checked, service)
      if (e.target.checked) {
        this.local_selected_services.push(service._id)
      } else {
        const index = this.local_selected_services.indexOf(service._id)
        this.local_selected_services.splice(index, 1)
      }
    }
  }
}
</script>

<style lang="scss">
.popup-row {
  padding: 10px;
  align-items: center;

  span {
    padding: 0 10px;
  }
}
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}
.popup-background {
  width: 400px;
  padding: 20px;
  background: white;
  border: 1px solid #555555;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 25%);
  max-height: 70vh;
  overflow: scroll;
}
.popup-button {
  padding: 10px 20px;
  background: #0c85d0;
  color: white;
  display: inline-block;
  border-radius: 7px;
  cursor:pointer;
}
</style>
